<template>
  <v-dialog persistent v-model="get_dialogMain.dialog" :width="get_dialogMain.withWindows" justify-center>
      <v-card width="auto" tile>
        <v-toolbar dense dark color="blue darken-2">
            <v-toolbar-title>
                <h3>{{get_dialogMain.title}}</h3>
            </v-toolbar-title>
        <v-spacer/>
            <v-btn icon dark @click="HIDDE_DIALOG_MAIN">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text class="my-1">
          <v-row dense>
            <v-col cols="12">
              <FormsMain :formCreate="form" :on-success="saveEquipo" :on-cancel="closeDialog" :model="descripcion" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import FormsMain from '@/components/forms/formsMain'
export default {
  name: 'dialogMain',
  props: ['model'],
  data: () => ({
    form: {
      status_start: {
        formulario: {
          fields: []
        }
      },
      status_finish: {
        formulario: {
          fields: []
        },
        estatus: ''
      }
    },
    descripcion: {}
  }),
  components: {
    FormsMain
  },
  mounted () {
    this.user = this.$cookies.get('user')
    this.getFormDataUrl('ma.options')
    if (!this.model.item.descripcion.interno) this.model.item.descripcion.interno = 'NO'
    this.descripcion = Object.assign({}, this.model.item.descripcion)
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    addInsumosView (item) {
      this.showInsumo = true
    },
    tableAction (item) {
      this[item.action](item.item)
    },
    ...mapActions(['getFormServicesAction', 'postExecuteAction']),
    getFormDataUrl (url) {
      const router = this.get_urls[url]
      this.getFormServicesAction({ url: router, params: `/${this.model.item.actividad.tipo_proceso_id}` })
    },
    saveEquipo (model) {
      model.empleado = this.user.empleado_id
      model.departamento = this.user.departamento_id
      if (this.get_dialogMain.type !== 'create') {
        model.id = this.model.item.id
      }
      // console.log('model', model)
      const router = this.get_urls['ma.execute']
      this.postExecuteAction({ url: router, data: model })
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'RELOAD_DATA_OBJECT', 'CLEAR_OBJECTS_OPTIONS', 'CLEAR_OBJECTS_MODEL']),
    closeDialog () {
      this.HIDDE_DIALOG_MAIN()
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_options', 'get_model', 'get_objectFind'])
  },
  watch: {
    get_options (vals) {
      if (vals) {
        vals.accion = 'toEditSolicitud'
        vals.status_finish.nombre = 'Editar Solicitud'
        this.form = vals
      }
    },
    get_model (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error !',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'succes',
        icon: 'success',
        title: 'Exitoso!',
        text: 'Registro agregado correctamente !!'
      })
      this.RELOAD_DATA_OBJECT(val)
      this.closeDialog()
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS_OPTIONS()
    this.CLEAR_OBJECTS_MODEL()
  }
}
</script>
<style></style>
